<button *ngIf="session.authToken && isMenuCollapsed" class="open-menu" mat-icon-button type="button"
        (click)="toggleMenuCollapsed()" aria-label="Open menu" aria-controls="main-navigation" [attr.aria-expanded]="false">
  <mat-icon>menu</mat-icon>
</button>

<mat-drawer-container class="app-shell" (backdropClick)="isMenuCollapsed = true">
  <mat-drawer class="app-sidebar" [mode]="isCompact ? 'over' : 'side'"
              [opened]="!!session.authToken && !isMenuCollapsed" (closedStart)="isMenuCollapsed = true">
    <div class="sidebar-layout">
      <div class="sidebar-heading">
        <div class="brand">{{ customerSupportOnly ? 'Brightstar' : 'Backoffice' }}
          <span *ngIf="customerSupportOnly">Backoffice</span>
        </div>
        <button mat-icon-button type="button" (click)="toggleMenuCollapsed()" aria-label="Collapse menu"
                aria-controls="main-navigation" [attr.aria-expanded]="true">
          <mat-icon>keyboard_double_arrow_left</mat-icon>
        </button>
      </div>

      <nav id="main-navigation" class="navigation" aria-label="Main navigation">
        <div class="primary-navigation" *ngIf="session.isManager()">
          <a *ngFor="let item of primaryLinks" class="nav-item" [routerLink]="item.route"
             routerLinkActive="active" [routerLinkActiveOptions]="routeMatchOptions" ariaCurrentWhenActive="page">
            <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon><span class="nav-label">{{ item.label }}</span>
          </a>
        </div>

        <a *ngIf="!session.isAdmin() && session.user?.roles?.includes('MANAGER')" class="nav-item"
           routerLink="/evaluation-catalog" routerLinkActive="active" ariaCurrentWhenActive="page">
          <mat-icon aria-hidden="true">rule</mat-icon><span class="nav-label">Evaluation rules</span>
        </a>

        <div class="navigation-groups" *ngIf="session.isAdmin()">
          <details *ngFor="let group of navigationGroups; trackBy: trackGroup" class="nav-group"
                   [open]="expandedGroups.has(group.id)"
                   routerLinkActive="active-group" [routerLinkActiveOptions]="routeMatchOptions">
            <summary (click)="toggleGroup(group.id, $event)">
              <mat-icon aria-hidden="true">{{ group.icon }}</mat-icon><span class="nav-label">{{ group.label }}</span>
              <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
            </summary>
            <div class="group-items">
              <ng-container *ngFor="let item of group.items; trackBy: trackItem">
                <a *ngIf="item.route; else action" class="nav-item" [routerLink]="item.route"
                   routerLinkActive="active" [routerLinkActiveOptions]="routeMatchOptions" ariaCurrentWhenActive="page">
                  <span class="nav-label">{{ item.label }}</span>
                </a>
                <ng-template #action>
                  <button class="nav-item" type="button" (click)="runAction(item.action)">
                    <span class="nav-label">{{ item.label }}</span>
                  </button>
                </ng-template>
              </ng-container>
            </div>
          </details>
        </div>
      </nav>

      <div class="sidebar-footer">
        <button *ngIf="session.isModerator() && (customerSupportOnly || !session.isAdmin())" class="nav-item"
                type="button" (click)="runAction('webview')">
          <mat-icon aria-hidden="true">web</mat-icon><span class="nav-label">Webview</span>
        </button>
        <button class="nav-item" type="button" (click)="logout()">
          <mat-icon aria-hidden="true">logout</mat-icon><span class="nav-label">Logout</span>
        </button>
      </div>
    </div>
  </mat-drawer>
  <mat-drawer-content [class.menu-collapsed]="session.authToken && isMenuCollapsed">
    <router-outlet />
  </mat-drawer-content>
</mat-drawer-container>
